import { useState } from 'react';
import { ReviewDetailsProps } from './type';
import { useTranslation } from 'react-i18next';
import ShowEye from '../../../assets/show_eye.png';
import CloseEye from '../../../assets/close_eye.png';
import { getMaskedPassword } from '../../../utils/helper';

const ReviewDetails = ({ venueData }: ReviewDetailsProps) => {
  const { t } = useTranslation();
  const [visiblePasswords, setVisiblePasswords] = useState<{
    [key: string]: boolean;
  }>({});

  const togglePasswordVisibility = (branchId: string) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [branchId]: !prev?.[branchId],
    }));
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Branch Details */}
      {venueData?.venueBranches?.map((branch, index) => (
        <div key={branch?.id} className="mb-5">
          {/* Venue Name */}
          <div className="flex w-full mb-3">
            <label className="w-[40%] text-black font-helvetica text-xs font-[600] text-left">
              {t('venueSetup.venue')}
            </label>
            <label className="w-full text-black font-helvetica text-xs font-[500] text-left">
              {venueData?.venue?.name}
            </label>
          </div>

          <div className="flex w-full mb-3">
            <label className="w-[40%] text-black font-helvetica text-xs font-[600] text-left">
              {t('venueSetup.venueBranchName')}
            </label>
            <label className="w-full text-black font-helvetica text-xs font-[500] text-left">
              {branch?.name}
            </label>
          </div>

          {branch?.password?.trim() !== '' && (
            <>
              <div className="flex w-full mb-2">
                <label className="w-[40%] text-black font-helvetica text-xs font-[600] text-left">
                  {t('venueSetup.universalStaffLogin')}
                </label>
                <label className="w-full text-black font-helvetica text-xs font-[500] text-left">
                  {branch?.email}
                </label>
              </div>
              <div className="flex w-full relative">
                <label className="w-[40%] text-black font-helvetica text-xs font-[600] text-left"></label>
                <div className="w-full text-black font-helvetica text-xs font-[500] text-left flex items-center">
                  <span className="text-[#0014FF]">
                    {visiblePasswords?.[branch?.id]
                      ? branch?.password
                      : getMaskedPassword(branch?.password)}
                  </span>
                  <div
                    className="ml-2 cursor-pointer"
                    onClick={() => togglePasswordVisibility(branch?.id)}
                  >
                    <img
                      src={visiblePasswords?.[branch?.id] ? ShowEye : CloseEye}
                      alt={
                        visiblePasswords?.[branch?.id]
                          ? 'Hide Password'
                          : 'Show Password'
                      }
                      className="w-5 h-3"
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReviewDetails;
